import React from 'react';
import './Skeleton.css';

/**
 * Base Skeleton Component
 * Renders a pulsing placeholder for loading content
 * 
 * @param {string} variant - 'text', 'circular', 'rectangular', 'rounded'
 * @param {string|number} width - Width of the skeleton
 * @param {string|number} height - Height of the skeleton
 * @param {string} className - Additional CSS classes
 * @param {boolean} animation - Whether to animate (default: true)
 */
const Skeleton = ({
  variant = 'text',
  width,
  height,
  className = '',
  animation = true,
  style = {},
}) => {
  const getVariantClass = () => {
    switch (variant) {
      case 'circular':
        return 'skeleton-circular';
      case 'rectangular':
        return 'skeleton-rectangular';
      case 'rounded':
        return 'skeleton-rounded';
      case 'text':
      default:
        return 'skeleton-text';
    }
  };

  const computedStyle = {
    ...style,
    width: width || (variant === 'text' ? '100%' : undefined),
    height: height || (variant === 'text' ? '1em' : undefined),
  };

  return (
    <div
      className={`skeleton ${getVariantClass()} ${animation ? 'skeleton-animate' : ''} ${className}`}
      style={computedStyle}
      aria-hidden="true"
    />
  );
};

export default Skeleton;
